const namespace = 'DEBT_PRODUCTS_';

export const CONSTANTS = {
    UPDATE_DEBT_PRODUCTS_DATA: `${namespace}UPDATE_DEBT_PRODUCTS_DATA`,
    GET_DEBT_PRODUCTS_DATA: `${namespace}GET_DEBT_PRODUCTS_DATA`,
    // Normalized state actions
    SET_NORMALIZED_ROWS: `${namespace}SET_NORMALIZED_ROWS`,
    UPDATE_PRODUCT: `${namespace}UPDATE_PRODUCT`,
    UPDATE_LENDER: `${namespace}UPDATE_LENDER`,
    TOGGLE_PRODUCT_EXPAND: `${namespace}TOGGLE_PRODUCT_EXPAND`,
    BATCH_UPDATE_PRODUCTS: `${namespace}BATCH_UPDATE_PRODUCTS`,
    BATCH_UPDATE_LENDERS: `${namespace}BATCH_UPDATE_LENDERS`,
    // Saga actions
    GENERATE_PRODUCT_METRICS: `${namespace}GENERATE_PRODUCT_METRICS`,
    GENERATE_PRODUCT_METRICS_SUCCESS: `${namespace}GENERATE_PRODUCT_METRICS_SUCCESS`,
    GENERATE_PRODUCT_METRICS_FAILURE: `${namespace}GENERATE_PRODUCT_METRICS_FAILURE`,
    // Restore state action
    RESTORE_DEBT_PRODUCTS_STATE: `${namespace}RESTORE_DEBT_PRODUCTS_STATE`,
};

export const UPDATE_SOURCES = {
    UPDATE_EXPANDED_ROW: 'UPDATE_EXPANDED_ROW',
    UPDATE_PRODUCT_FIELD: 'UPDATE_PRODUCT_FIELD',
    UPDATE_LENDER_FIELD: 'UPDATE_LENDER_FIELD',
};

export const GET_SOURCES = {
    GET_HEADERS: 'GET_HEADERS',
    GET_ROWS: 'GET_ROWS',
};
